(() => {
window.addEventListener("DOMContentLoaded", (e)=>{
    let buttons = [
        ...document.querySelectorAll(".button")
    ];
    buttons.forEach((button)=>{
        let textEn = button.dataset.en;
        let textCn = button.dataset.cn;
        let innerHTML = `
    <div class="button__container">
      <span class="button__text button__text--en"> ${textEn} </span>
      <span class="button__text button__text--cn"> ${textCn} </span>
    </div>
    `;
        if (/Mobi|Android/i.test(navigator.userAgent)) innerHTML = `
      <div class="button__container">
        <span class="button__text button__text--en"> ${textCn} </span>
      </div>
      `;
        button.innerHTML = innerHTML;
    });
});


let $6ef9319284ed8331$var$wechatIcons = document.querySelectorAll(".social-media__wechat .wechat");
let $6ef9319284ed8331$var$qrcodeContainer = document.querySelector(".qrcode-container");
let $6ef9319284ed8331$var$closeButton = $6ef9319284ed8331$var$qrcodeContainer.querySelector(".close-button");
$6ef9319284ed8331$var$wechatIcons.forEach((wechat)=>{
    wechat.addEventListener("click", ()=>{
        $6ef9319284ed8331$var$qrcodeContainer.classList.add("shown");
    });
});
$6ef9319284ed8331$var$qrcodeContainer.addEventListener("click", ()=>{
    $6ef9319284ed8331$var$qrcodeContainer.classList.remove("shown");
});




})();
//# sourceMappingURL=app.js.map
